// extracted by mini-css-extract-plugin
module.exports = {"ForgotPasswordContainer":"ForgotPassword_ForgotPasswordContainer__wviUm","ForgotPassword":"ForgotPassword_ForgotPassword__1p8xf"};